/** BUG-015 — strip the markdown bold markers (and simple italics)
 * the vision pass embedded in matter_figures.description so the
 * gallery's plain-text caption doesn't leak ``**Figure Type:**``
 * style noise. Also used by Stage 1 Technology Basics, whose LLM
 * text carries the same markers. Display-layer only — the stored
 * text is unchanged. */
export function stripMarkdown(text: string | null | undefined): string {
  if (!text) return '';
  return text
    .replace(/\*\*(.*?)\*\*/g, '$1')   // **bold**
    .replace(/__(.*?)__/g, '$1')        // __bold__
    .replace(/(^|[^\w*])\*([^*\n]+)\*/g, '$1$2')  // *italic* (skip **)
    .replace(/(^|[^\w_])_([^_\n]+)_/g, '$1$2')    // _italic_ (skip __)
    // An unpaired ** ("3-axis accelerometer**") is left over when the
    // model splits a bold run across lines or fields; never prose.
    .replace(/\*\*/g, '');
}
